import * as XLSX from 'xlsx';

export const downloadAsExcel = (data, fileName, sheetName = 'Report') => {
  if (!data || data.length === 0) {
    console.warn('No data available to download.');
    return;
  }

  try {
    // Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create workbook and add worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    const finalFileName = `${fileName}_${timestamp}.xlsx`;

    // Write and download file
    XLSX.writeFile(workbook, finalFileName);

    return true;
  } catch (error) {
    console.error('Error generating Excel file:', error);
    throw new Error('Failed to generate Excel file');
  }
};

export const formatDataForExcel = (data, reportType) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }

  // You can add custom formatting logic here based on report type
  switch (reportType) {
    case 'raw':
      // For raw data, return as is
      return data;
    case 'attendance':
      // Format attendance data
      return data.map((item) => ({
        'Employee ID': item.employeeId || item.empId,
        'Employee Name': item.employeeName || item.empName,
        'Training Name': item.trainingName,
        'Attendance Status': item.attendanceStatus,
        Date: item.date,
        'Batch ID': item.batchId,
      }));
    case 'performance':
      // Format performance data
      return data.map((item) => ({
        'Employee ID': item.employeeId || item.empId,
        'Employee Name': item.employeeName || item.empName,
        'Training Name': item.trainingName,
        'Completion Rate': item.completionRate,
        Score: item.score,
        Status: item.status,
      }));
    case 'schedule':
      // Format schedule data
      return data.map((item) => ({
        'Training Name': item.trainingName,
        'Start Date': item.startDate,
        'End Date': item.endDate,
        Trainer: item.trainer,
        Location: item.location,
        Status: item.status,
      }));
    default:
      return data;
  }
};
